import { sharedStyles } from './shared/sharedStyles.js';

function HighlightBox() {
  return (
    <div style={{
      background: sharedStyles.colors.primaryLight,
      borderRadius: '16px',
      padding: '2.5rem',
      textAlign: 'center'
    }}>
      <h3 style={{
        fontSize: '1.5rem',
        fontWeight: '700',
        color: sharedStyles.colors.textPrimary,
        marginBottom: '1rem'
      }}>
        Built for Podcasters, By Podcasters
      </h3>
      <p style={{
        fontSize: '1rem',
        color: sharedStyles.colors.textPrimary,
        lineHeight: '1.8'
      }}>
        We understand the podcasting workflow because we've lived it. We know the excitement of finding
        the perfect guest and the frustration of outreach that goes nowhere. Whether you're launching your
        first show or producing your hundredth episode, Conviviality is here to help you find guests who
        make your podcast shine.
      </p>
    </div>
  );
}

export default HighlightBox;
